import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const communicationEnvelope = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_15522_118240)">
<path d="M13.8182 2C15.0198 2 16 2.89848 16 4V12C16 13.1015 15.0198 14 13.8182 14H2.18182C0.980157 14 0 13.1015 0 12V4C0 2.89848 0.980157 2 2.18182 2H13.8182ZM14.5454 5.28L8.41706 9.21282C8.16665 9.3735 7.83335 9.3735 7.58294 9.21282L1.45448 5.28067L1.45455 12C1.45455 12.3651 1.78348 12.6667 2.18182 12.6667H13.8182C14.2165 12.6667 14.5455 12.3651 14.5455 12L14.5454 5.28ZM13.8182 3.33333H2.18182C1.89964 3.33333 1.65229 3.48464 1.53202 3.7027L8 7.8529L14.468 3.7027C14.3477 3.48464 14.1004 3.33333 13.8182 3.33333Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_15522_118240">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`
);
